import { useEffect, useState } from "react";

const MIN_WIDTH = 768;

export default function DeviceSizeWarning() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const checkSize = () => {
      setShowWarning(window.innerWidth < MIN_WIDTH);
    };

    checkSize();
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  if (!showWarning) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.box}>
        <h2>⚠️ Screen Too Small</h2>
        <p>
          This app is optimized for tablets and larger screens.
          <br />
          Please use an iPad, tablet, or desktop for the best experience.
        </p>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  box: {
    background: "#fff",
    padding: "24px",
    borderRadius: "8px",
    textAlign: "center",
    maxWidth: "320px",
  },
};
